export { SimpleGrid } from "@mantine/core";
export type { SimpleGridProps } from "@mantine/core";
